module.exports = __webpack_public_path__ + "img/service6DE.0e6f5102.svg";